'use client';

import { css } from '@bts-web/utils-style-engine';
import { useClientTranslation } from '@bts-web/utils-lokalise';
import { ErrorMessage } from '../../common/components';

export const GenericErrorMessage = () => {
  const { t } = useClientTranslation();

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 'calc(100vh - 75px)',
      })}
    >
      <ErrorMessage
        title={t('general_error_headline')}
        withRetryButton
        withPortfolioButton
      />
    </div>
  );
};
